module.exports = __webpack_public_path__ + "static/media/icon_trash_normal.a059692c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_trash_normal.svg
// module id = 666
// module chunks = 0